/*
   component Header
   ========================================================================== */

export default class Header {
  constructor(element) {
    this.element = element;
    this.options = {
      treshold: 0.1,
    };
    this.scrollPosition = 0;
    this.lastScrollPosition = 0;
    this.html = document.documentElement;
    this.scrolls = document.querySelector('.scrolls');

    this.init();
    this.initNavMobile();
  }

  init() {
    this.setOptions();

    window.addEventListener('scroll', this.onScroll.bind(this));
  }

  setOptions() {
    //vérifier les att data sur composante
  }

  onScroll() {
    this.lastScrollPosition = this.scrollPosition;
    this.scrollPosition = document.scrollingElement.scrollTop;

    this.setHeaderState();
    this.setDirections();
  }

  setHeaderState() {
    if (
      this.scrollPosition >=
      document.scrollingElement.scrollHeight * this.options.treshold
    ) {
      this.html.classList.add('header-is-hidden');
    } else {
      this.html.classList.remove('header-is-hidden');
    }
  }

  setDirections() {
    if (this.scrollPosition >= this.lastScrollPosition) {
      //down
      this.html.classList.add('is-scrolling-down');
      this.html.classList.remove('is-scrolling-up');

      //cacher le scrolls

      this.scrolls.classList.remove('is-active');
    } else {
      //up
      this.html.classList.add('is-scrolling-up');
      this.html.classList.remove('is-scrolling-down');
    }
  }

  initNavMobile() {
    const toggle = this.element.querySelector('.js-toggle');
    const buttons = document.querySelectorAll('.js-btn-mobile');

    toggle.addEventListener('click', this.onToggleNav.bind(this));

    for (let i = 0; i < buttons.length; i++) {
      const button = buttons[i];
      console.log('hi');

      button.addEventListener('click', this.onMenu.bind(this));
    }
  }

  onToggleNav() {
    this.html.classList.toggle('nav-is-active');
  }

  onMenu() {
    console.log('hello');

    this.html.classList.toggle('nav-is-active');
  }
}
